<template>
  <div class="mt-6 latest-medical-informations">
    <v-row class="my-2">
      <h2>
        医療情報の配信履歴
      </h2>
    </v-row>
    <v-row>
      <medical-information-cards
        :medical-informations="latestMedicalInformations"
      />
    </v-row>
    <v-row>
      <v-col class="pl-0 d-flex justify-end">
        <v-btn
          variant="flat"
          border="0"
          append-icon="mdi-chevron-right"
          height="40"
          :color="color.mainColor()"
          :to="{ path: '/medical_informations' }"
          class="text-white font-weight-bold"
        >
        配信履歴一覧
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed } from "vue"
import medicalInformationCards from "./../shared/MedicalInformation.vue"
import { MedicalInformation } from "../../stores/store_types"
import { useStore } from "../../stores/index"
import { themeColor } from "../../service/theme_color"

export default defineComponent({
  name: "LatestMedicalInformationsPart",
  components: {
    medicalInformationCards
  },
  setup() {
    const store = useStore()
    // settings
    const color = themeColor()

    // data
    const latestMedicalInformations = computed(() => store.getters.latestMedicalInformations as Array<MedicalInformation>)

    onMounted(() => {
      store.dispatch("fetchLatestMedicalInformations")
    })

    return {
      latestMedicalInformations,
      color
    }
  }
})
</script>
